import { NodeDetailsDto } from "domains/nodes/components/common/NodeDetailsDto";
import { NodeTree } from "domains/nodes/components/node-selector";
import { Typography } from "@mui/material";
import localisations from "../../../localisation";

type SelectParentStageProps = {
    fieldCompanyId: number;
    fields: {
        parentHierarchyNodeId?: number | null;
        expandedNodes: string[];
    };
    handleFieldChange: (fields: any) => void;
};

function SelectParentStage(props: SelectParentStageProps) {
    const { heading, blurb } = localisations.createPartition.stages.selectParent;
    const { fields, handleFieldChange } = props;

    const onSelected = (nodeId: string, nodeDetails: NodeDetailsDto) => {
        fields.parentHierarchyNodeId = nodeDetails && nodeDetails.allowPartitions ? fields.parentHierarchyNodeId = parseInt(nodeId) : null;
        handleFieldChange(fields);
    };

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>

            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>

            <NodeTree
                showNoPartitionsAllowedTooltip={true}
                fieldCompanyId={props.fieldCompanyId}
                onNodeSelect={onSelected}
                selectedNodeId={fields?.parentHierarchyNodeId?.toString()}
                expandedNodes={fields.expandedNodes ?? []}
                onToggle={(expandedNodes: string[]) => {
                    fields.expandedNodes = expandedNodes;
                    handleFieldChange(fields);
                } }
            />
        </>
    );
}

export default SelectParentStage;
